var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplierUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#DADEE3",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4197 23.0737C32.5241 22.3615 30.1677 21.9395 27.6141 21.9395C25.0606 21.9395 22.7042 22.3615 20.8086 23.0737",
    stroke: "#757575",
    strokeWidth: 1.13426,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9091 23.0751L21.0817 21.4729C20.4252 20.2017 20.097 19.5661 20.3037 19.0043C20.5104 18.4425 21.1466 18.2414 22.4189 17.8391L26.9227 16.4153C27.2301 16.3181 27.3839 16.2695 27.5415 16.2695C27.6993 16.2695 27.8531 16.3181 28.1605 16.4153L32.9675 17.935C34.1137 18.2973 34.6867 18.4785 34.9052 18.9871C35.1237 19.4956 34.8889 20.1018 34.4195 21.314L33.7373 23.0751",
    stroke: "#757575",
    strokeWidth: 1.13426,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9414 23.0742V25.031C21.9414 27.065 22.9866 28.9499 24.6948 29.9964L25.2784 30.3539C26.7152 31.2341 28.5102 31.2341 29.947 30.3539L30.5306 29.9964C32.2388 28.9499 33.284 27.065 33.284 25.031V23.0742",
    stroke: "#757575",
    strokeWidth: 1.13426,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0188 29.8809L32.1531 33.2836M32.1531 33.2836L30.6005 34.6395C29.1782 35.8817 28.4672 36.5027 27.616 36.5027C26.7649 36.5027 26.0538 35.8817 24.6316 34.6395L23.079 33.2836M32.1531 33.2836L34.12 33.9392C35.2521 34.3166 35.8181 34.5053 36.3206 34.797C36.8125 35.0825 37.2586 35.4403 37.644 35.8585C38.0377 36.2858 38.9586 37.8207 38.9586 38.9549M23.079 33.2836L24.2133 29.8809M23.079 33.2836L21.112 33.9392C19.98 34.3166 19.4139 34.5053 18.9115 34.797C18.4196 35.0825 17.9735 35.4403 17.5881 35.8585C17.1944 36.2858 16.2734 37.8207 16.2734 38.9549",
    stroke: "#757575",
    strokeWidth: 1.13426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierUserIcon);
export default __webpack_public_path__ + "static/media/supplier-user-icon.2e12e2965f63608462a393ddae286afd.svg";
export { ForwardRef as ReactComponent };